module.exports = __webpack_public_path__ + "media/professional.eac76b95.mp4";